var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{attrs:{"spin":true,"size":_vm.size,"color":"#6563FF"}},[_vm._v("spinner")])}
var staticRenderFns = []

export { render, staticRenderFns }